// extracted by mini-css-extract-plugin
module.exports = {"authorStatus":"CommentAuthorContainer-authorStatus-3cd41f7121bc8de9dea80ee6fb903e95"};